
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMeteorologicalInformation as ObiMeteorologicalInformationElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-meteorological-information.js';
 
 
 

 
 export const ObiMeteorologicalInformation = createComponent({
   react: React,
   tagName: 'obi-meteorological-information',
   elementClass: ObiMeteorologicalInformationElement,
   events: {
     
   }
  });
 
 